import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { fg } from '@confluence/feature-gating';
import {
	ONBOARDING_EXPERIENCES,
	IMPROVED_GET_STARTED_NTH_USER_PATH,
	NTH_USER_ONBOARDING_PAGE_VIEWED,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import {
	useSetOnboardingState,
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';

import { extractContentIdFromUrl } from './NthUserOnboardingFlag.tsx';

export const useNthUserOnboardingPageTracking = ({
	contentId = '',
	skip = false,
}: {
	contentId?: string;
	skip?: boolean;
} = {}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { setOnboardingState } = useSetOnboardingState();

	const {
		data: onboardingStateData,
		error: onboardingStateError,
		loading: onboardingStateLoading,
	} = useGetOnboardingState(
		[
			ONBOARDING_EXPERIENCES.IMPROVED_GET_STARTED_NTH_USER_PATH,
			ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_PAGE_VIEWED,
		],
		skip,
	);

	const deserializedState = deserializeState(onboardingStateData);
	const nthUserOnboardingPageViewed = deserializedState[NTH_USER_ONBOARDING_PAGE_VIEWED];
	const nthUserGSPage = deserializedState[IMPROVED_GET_STARTED_NTH_USER_PATH];

	useEffect(() => {
		if (skip || !fg('cc-engagement-getting-started-nth-user-gate')) {
			return;
		}

		if (!onboardingStateData || onboardingStateError || onboardingStateLoading) {
			return;
		}

		if (nthUserGSPage && extractContentIdFromUrl(nthUserGSPage) === contentId) {
			if (!nthUserOnboardingPageViewed) {
				createAnalyticsEvent({
					type: 'sendScreenEvent',
					data: {
						name: 'NthUserGettingStartedPage',
					},
				}).fire();
				setOnboardingState({
					key: ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_PAGE_VIEWED,
					value: 'true',
				});
			}
		}
	}, [
		contentId,
		createAnalyticsEvent,
		onboardingStateData,
		onboardingStateError,
		onboardingStateLoading,
		nthUserGSPage,
		nthUserOnboardingPageViewed,
		setOnboardingState,
		skip,
	]);
};
